import { useEffect, useRef, useState } from 'react';
// Defer expensive supporting requests until their cards approach the viewport.
export function useNearby() {
  const ref = useRef(null);
  const [ready, setReady] = useState(typeof IntersectionObserver === 'undefined');
  useEffect(() => {
    if (ready || !ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          setReady(true);
          observer.disconnect();
        }
      },
      { rootMargin: '400px' },
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, [ready]);
  return [ref, ready];
}
